module.exports = __webpack_public_path__ + "assets/images/layout-banner-left.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/layout-banner-left.svg
// module id = 21
// module chunks = 0